import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../CSS/Dashboard.css";
import { API_BASE_URL } from "../config/serverApiConfig";
import { Toaster } from "react-hot-toast";
import Cookies from "js-cookie";

function Dashboard() {
  const [toDoCandidatCount, setToDoCandidatCount] = useState(0);
  const [inProgressCandidatCount, setInProgressCandidatCount] = useState(0);
  const [preSelectedCount, setInPreselectedCount] = useState(0);
  const [archivedCandidatCount, setArchivedCandidatCount] = useState(0);
  const [newCandidatCount, setNewCandidatCount] = useState(0);
  const [contactedCandidatCount, setContactedCandidatCount] = useState(0);
  const [interestedCandidatCount, setInterestedCandidatCount] = useState(0);
  const [deniedCandidatCount, setDeniedCandidatCount] = useState(0);
  const [hiredCandidatCount, setHiredCandidatCount] = useState(0);
  const [firedCandidatCount, setFiredCandidatCount] = useState(0);
  const [collectingDocsCandidatCount, setCollectingDocsCandidatCount] = useState(0);
  const [noAnswerCandidatCount, setNoAnswerCandidatCount] = useState(0);
  const [finishedCandidatCount, setFinishedCandidatCount] = useState(0);
  const [deadLeadCandidatCount, setDeadLeadCandidatCount] = useState(0);
  const [toDoClientCount, setToDoClientCount] = useState(0);
  const [inProgressClientCount, setInProgressClientCount] = useState(0);
  const [signedClientCount, setSignedClientCount] = useState(0);
  const [archivedClientCount, setArchivedClientCount] = useState(0);
  const [loader, setLoader] = useState(false);

  const fetchCandidatCounts = async () => {
    return await fetch(API_BASE_URL + "getCounts", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    })
      .then((resd) => resd.json())
      .then((d) => d)
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchClientCounts = async () => {
    return await fetch(API_BASE_URL + "getLeadsCount", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    })
      .then((resd) => resd.json())
      .then((d) => d)
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    fetchCandidatCounts()
      .then((data) => {
        setToDoCandidatCount(data.toDoCount);
        setInProgressCandidatCount(data.inProgressCount);
        setArchivedCandidatCount(data.archivedCount);
        setInPreselectedCount(data.preSelectedCount);
        setNewCandidatCount(data.newCount);
        setContactedCandidatCount(data.contactedCount);
        setInterestedCandidatCount(data.interestedCount);
        setDeniedCandidatCount(data.deniedCount);
        setHiredCandidatCount(data.hiredCount);
        setFiredCandidatCount(data.firedCount);
        setCollectingDocsCandidatCount(data.collectingDocsCount);
        setNoAnswerCandidatCount(data.noAnswerCount);
        setFinishedCandidatCount(data.finishedCount);
        setDeadLeadCandidatCount(data.deadLeadsCount);
        setLoader(true);
      })
      .catch((err) => err);

    fetchClientCounts()
      .then((resp) => {
        setToDoClientCount(resp.toDoCount);
        setInProgressClientCount(resp.inProgressCount);
        setSignedClientCount(resp.signedCount);
        setArchivedClientCount(resp.archivedCount);
      })
      .catch((err) => {
        console.log(err);
      });
  });

  return (
    <>
      <Toaster
        position="top-right"
        containerStyle={{ zIndex: "999" }}
      />

      <div className="tw-bg-white tw-w-full tw-p-4 tw-shadow-lg tw-rounded-xl tw-my-4">
        <h2 className="tw-text-black tw-font-bold tw-text-2xl">Stats Candidates/Employees</h2>
      </div>

      <div className="tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4">
        <Link to="/candidates" state={{ status: "New" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Oval.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {newCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      New
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "Contacted" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Oval.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {contactedCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Contacted
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "Interested" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Oval.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {interestedCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Interested
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "Collecting Docs" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Preselected.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {collectingDocsCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Collecting Docs
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>


        <Link to="/candidates" state={{ status: "Hired" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/CardPre.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {hiredCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Hired
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "No Answer" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Oval.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {noAnswerCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      No Answer
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "Fired" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Oval.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {firedCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Fired
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "Dead" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Oval.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {deadLeadCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Dead Leads
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "Finished" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Oval.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {finishedCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Finished
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "To-Do" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Oval.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {toDoCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      To do
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "Pre-Selected" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Preselected.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {preSelectedCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Pre-Selected
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "In-Progress" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/CardTick.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {inProgressCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      In-Progress
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/candidates" state={{ status: "Archived" }}>
          <div
            className="card mb-0 hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/multiply.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {archivedCandidatCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Archived
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      <div className="tw-bg-white tw-w-full tw-p-4 tw-shadow-lg tw-rounded-xl tw-my-4">
        <h2 className="tw-text-black tw-font-bold tw-text-2xl">Stats Leads / Clients</h2>
      </div>

      <div className="tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4">
        <Link to="/clientTodo">
          <div
            className="card hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/Oval.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {toDoClientCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      To Do
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/clientProgress">
          <div
            className="card hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/CardPre.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {signedClientCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        {" "}
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Proposal Signed
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/clientContract">
          <div
            className="card hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/CardTick.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStyling text-end">
                          {inProgressClientCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        {" "}
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Contrat en cours / Done
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        <Link to="/archived">
          <div
            className="card hover:tw-shadow-xl"
            style={{ padding: "5px 10px", borderRadius: "10px" }}
          >
            <div className="card-content">
              <div className="card-body">
                <div className="row media d-flex">
                  <div className="col-6 align-self-center">
                    <img alt="..."
                      src={require("../images/multiply.svg").default}
                    />
                  </div>
                  <div className="col-6 media-body text-right">
                    {loader ? (
                      <>
                        <h3 className="pt-1 NumberStylingARchived text-end">
                          {archivedClientCount}
                        </h3>
                      </>
                    ) : (
                      <>
                        {" "}
                        <div className="d-flex justify-content-end">
                          <div className="Das-loader"></div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="text-start">
                    <h3 className="fontStyling">
                      Annulé / Archivé / Canceled
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
}
export default Dashboard;
